/**
 * SPEC-2026-08-webhook-dedicated-database — mirrors the backend enums in
 * `trendmulti-core/src/enum/webhook-audit.enum.ts`. Kept as a copy rather than a
 * shared import because the web workspace cannot reach into the backend
 * libraries; the values are a contract and must not drift.
 */
export enum WebhookAuditDirectionEnum {
  RECEIVED = 'RECEIVED',
  DELIVERED = 'DELIVERED',
}

export enum WebhookAuditSurfaceEnum {
  PROVIDER_INBOUND = 'PROVIDER_INBOUND',
  INTEGRATION_INBOUND = 'INTEGRATION_INBOUND',
  OUTBOUND_DELIVERY = 'OUTBOUND_DELIVERY',
}

export enum WebhookAuditOutcomeEnum {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
